'use client';

import { useState } from 'react';
import Link from 'next/link';
import { Search, FileText, Download } from 'lucide-react';

const FICHAS = [
  { id: '1', title: 'Total de Fuerza Laboral', code: 'ECO-001', updated: '12/10/2025' },
  { id: '2', title: '% Cobertura Red de Agua Potable', code: 'INF-042', updated: '05/09/2025' },
  { id: '3', title: '% Días Calidad Aire Aceptable', code: 'AMB-011', updated: '20/11/2025' },
  { id: '4', title: 'Tasa de Desempleo Local', code: 'ECO-002', updated: '15/10/2025' },
  { id: '5', title: 'Consumo Energía per Cápita', code: 'SRV-089', updated: '01/12/2025' },
  { id: '6', title: 'Alumnos Matriculados Nivel Primario', code: 'EDU-033', updated: '14/08/2025' },
];

export default function FichasMetodologicasPage() {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredFichas = FICHAS.filter(ficha => 
    ficha.title.toLowerCase().includes(searchTerm.toLowerCase()) || 
    ficha.code.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleDownloadZip = async () => {
    try {
      const JSZip = (await import('jszip')).default;
      const zip = new JSZip();

      const folder = zip.folder("fichas_metodologicas");
      if (!folder) return;

      FICHAS.forEach(ficha => {
        const content = `Ficha Metodológica\nCódigo: ${ficha.code}\nIndicador: ${ficha.title}\nÚltima actualización: ${ficha.updated}\n\nNota: Este es un archivo de prueba.`;
        // Sanitizar nombre de archivo
        const safeTitle = ficha.title.replace(/[^a-z0-9]/gi, '_').toLowerCase();
        folder.file(`${ficha.code}_${safeTitle}.txt`, content);
      });

      const blob = await zip.generateAsync({ type: "blob" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = "fichas_metodologicas.zip";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error al generar el ZIP", error);
      alert("Ocurrió un error al intentar generar el archivo ZIP.");
    }
  };

  return (
    <main className="max-w-5xl mx-auto w-full px-8 py-16 flex-1">
      <div className="mb-12 text-center">
        <div className="w-16 h-16 bg-[#EFF6FF] text-[#0053D6] rounded-full flex items-center justify-center mx-auto mb-6">
          <FileText className="w-8 h-8" />
        </div>
        <h2 className="text-4xl font-[family-name:var(--font-righteous)] text-[#002B5B] mb-4">
          Fichas Metodológicas
        </h2>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto">
          Directorio de especificaciones técnicas. Consulta el detalle de cálculo, fuentes de datos, responsables y normativa ISO de cada indicador.
        </p>
      </div>

      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
        <div className="p-6 border-b border-gray-100 bg-gray-50 flex flex-col md:flex-row gap-4 justify-between items-center">
          <div className="relative w-full md:w-96">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <Search className="h-4 w-4 text-gray-400" />
            </div>
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Buscar por código o nombre..."
              className="w-full pl-10 pr-4 py-2 rounded-lg border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-[#002B5B]"
            />
          </div>
          <button 
            onClick={handleDownloadZip}
            className="flex items-center gap-2 text-sm font-bold text-[#0053D6] bg-[#EFF6FF] px-4 py-2 rounded-lg hover:bg-[#DBEAFE] transition-colors w-full md:w-auto justify-center">
            <Download className="w-4 h-4" />
            Descargar Todas (ZIP)
          </button>
        </div>

        <ul className="divide-y divide-gray-100">
          {filteredFichas.length > 0 ? (
            filteredFichas.map((ficha) => (
            <li key={ficha.id} className="p-6 hover:bg-gray-50 transition-colors flex flex-col sm:flex-row sm:items-center justify-between gap-4">
              <div>
                <div className="flex items-center gap-3 mb-1">
                  <span className="text-xs font-mono font-bold text-gray-400 bg-gray-100 px-2 py-1 rounded">
                    {ficha.code}
                  </span>
                  <span className="text-xs text-gray-400">
                    Actualizada: {ficha.updated}
                  </span>
                </div>
                <h3 className="text-lg font-bold text-gray-900">{ficha.title}</h3>
              </div>
              <div className="flex items-center gap-2">
                <Link 
                  href={`/indicadores/${ficha.id}`}
                  className="px-4 py-2 text-sm font-bold text-gray-600 border border-gray-200 rounded-lg hover:bg-gray-100 transition-colors"
                >
                  Ver Online
                </Link>
                <button 
                  onClick={() => window.print()}
                  className="px-4 py-2 text-sm font-bold text-white bg-[#0053D6] rounded-lg hover:bg-[#003876] transition-colors flex items-center gap-2"
                >
                  <Download className="w-4 h-4" /> PDF
                </button>
              </div>
            </li>
          ))
          ) : (
            <li className="p-12 text-center text-gray-500 text-sm">
              No se encontraron fichas que coincidan con la búsqueda.
            </li>
          )}
        </ul>
      </div>
    </main>
  );
}
